export const REACT_APP_TERMS_AND_CONDITIONS_URL = "https://drive.google.com/file/d/1C509laRz_G3yDcDCyB81-Iwie8lPFywI/view";
export const REACT_APP_LOGO_MAX_SIZE_MB = 10;
export const REACT_APP_LOGO_MAX_RES_WIDTH = 400;
export const REACT_APP_LOGO_MAX_RES_HEIGHT =400;
export const REACT_APP_LOGO_ALLOWED_EXTENSIONS = ".png,.jpg,.jpeg,.pdf";
export const REACT_APP_CONFIRMATION_PWD = "J214BN6";
